import { render } from "./Verify.vue?vue&type=template&id=9b7e265a&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"

import "./Verify.vue?vue&type=style&index=0&id=9b7e265a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7e265a"]])

export default __exports__